<h2 mat-dialog-title>Logout</h2>
<mat-dialog-content class="mat-typography" style="padding-bottom: 0;">
    <p>Are you sure you want to logout?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="primary-btn sm-btn" mat-button mat-dialog-close (click)="logout()">Yes</button>
    <button class="secondary-btn sm-btn" mat-button mat-dialog-close>No</button>
</mat-dialog-actions>